// var currentVenue = document.getElementById("current-venue");
// var venuesWrap = document.getElementById("venues-wrap");
// var venuesList = document.getElementById("venues-ul");
// function venueListControl(open = true){
//     open ? venuesWrap.classList.add("open") : venuesWrap.classList.remove("open");
// }
// function losingFocus(){
//     venueListControl(false);
// }
// currentVenue.addEventListener("click", function(ev) {
//     venueListControl(true);
//     ev.stopPropagation();
// });
// document.body.addEventListener("click", function () {
//     venueListControl(false);
// }, false);
// window.onscroll = function(){ venueListControl(false) };

var currentVenue = document.querySelectorAll(".current-venue");
var currentVenueName = document.querySelector(".current-venue-li a").getAttribute("data-name");

function venueListControl(venuesWrap = null, open = true){
    if (!venuesWrap) {
        var venuesWraps = document.querySelectorAll(".venues-wrap");
        venuesWraps.forEach(el => {
            el.classList.remove('open');
        });
    } else {
        open ? venuesWrap.classList.add("open") : venuesWrap.classList.remove("open");
    }
}

function losingFocus(){
    venueListControl(false);
}

currentVenue.forEach(el => {
    var venuesWrap = el.parentNode;
    el.innerHTML = currentVenueName;
    el.addEventListener("click", function(ev) {
        venueListControl(venuesWrap, true);
        ev.stopPropagation();
    });
});

document.body.addEventListener("click", function () {
    venueListControl(null,false);
}, false);

window.onscroll = function(){ venueListControl(false) };
